export const environment = {
  production: true,
  apiUrl: 'https://apigateway.tessellon.com',
  appBaseUrl: 'https://apps.tessellon.com',
  dxproAppUrl: 'https://dxpro.tessellon.com',
  vennhealthAppUrl: 'https://vennhealth.tessellon.com',
  preciseAppUrl: 'https://precise.tessellon.com',
  biomarkersAppUrl: 'https://biomarkers.tessellon.com',
  legacyPreciseAppUrl: 'https://portal.tessellon.com',
  predictAppUrl: 'https://predict.tessellon.com',
  countyFipsAppUrl: 'https://countyfips.tessellon.com',
  tcriUrl: 'https://tcri.tessellon.com',
};
